import {
  EditTeamRequestAction, ExternalTeamsRequestAction, FetchClubRequestAction,
  FetchTeamIdRequestAction, FetchTeamRequestAction,
  FetchTeamsRequestAction, Tor24TeamsRequestAction,
} from '../../../../models/actions';
import { Team, TeamsByHash } from '../../../../models/Team';
import { Tor24Team, ExternalTeam } from '../../../../models/externalSystemIntegration';
import { Club } from '../../../../models/Club';

export type StateProps = {
  club: Club,
  externalTeams: ExternalTeam[];
  fetchTeams: () => FetchTeamsRequestAction;
  fetchTeam: (id: number) => FetchTeamRequestAction;

  loadingExternalTeams: boolean;
  tor24Teams: (
    tor24ClubId: string,
  ) => Tor24TeamsRequestAction;
  editTeam: (
    team: Team,
    deactivateTor24Integration?: boolean
  ) => EditTeamRequestAction;
  fetchTeamId: (clubId: number) => FetchTeamIdRequestAction;
  clubId: number | null;
  selectedPlayers: number[];
  teamsByHash: TeamsByHash;
  loading: boolean;
  editionSuccessful: boolean;
  error: boolean;
  errorMessage?: string;
  tor24TeamsByHash: { [key: string]: Tor24Team };
  tor24TeamsById: number[],
  fetchClubById: () => FetchClubRequestAction
  fetchExternalTeams: (externalClubId: string) => ExternalTeamsRequestAction;
};

export const ERROR_MESSAGE_TRANSLATIONS: { [key: string] : string } = {
  'team.paypal_url.invalid': 'UPDATE_TEAM.PAYPAL_URL_INVALID_ERROR',
};

export interface EditTeamProps extends StateProps {
}
